export default __webpack_public_path__ + "static/P53_UN0570020-b5c655b71e0da1c98474104b48092144.jpg";